export default __webpack_public_path__ + "static/vendorenvironmentalpolicy2021-cce7bb906e7183b5ac86840e2cb56d96.pdf";